import type { App } from 'vue';
import { role, rolefrom } from './role';

export const registerDirectives = (app: App) => {
  app.directive('role', role);
  app.directive('rolefrom', rolefrom);
};
